import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { Badge, IconButton, Popover, useMediaQuery } from '@mui/material';
import { NotificationsBox } from '@notifications/components/display/boxes';
import { useNotificationsBoxContext } from '@notifications/contexts';
import clsx from 'clsx';
import { useState } from 'react';

export const NotificationsButton = () => {
    const [notificationsAnchorEl, setNotificationsAnchorEl] = useState<null | HTMLElement>(null);
    const isBelowMd = useMediaQuery((theme) => theme.breakpoints.down('md'));

    const { unreadNotificationsTotalCount, hasNotifications, tabsActionRef } = useNotificationsBoxContext();

    return (
        <>
            <IconButton
                value="notifications"
                className="hidden md:inline-flex p-[9px] border border-solid border-neutral-600 group"
                onClick={(e) => setNotificationsAnchorEl(e.currentTarget)}
                sx={{
                    '&:hover': {
                        bgcolor: 'primary-700.main',
                    },
                    ...(Boolean(notificationsAnchorEl) && {
                        bgcolor: 'primary-800.main',
                    }),
                }}
            >
                <Badge
                    color="error"
                    variant="dot"
                    overlap="circular"
                    invisible={!hasNotifications && unreadNotificationsTotalCount === 0}
                >
                    <NotificationsOutlinedIcon
                        sx={{ fontSize: 25 }}
                        color="black"
                        className={clsx('group-hover:text-white transition-colors', {
                            'text-white': Boolean(notificationsAnchorEl),
                        })}
                    />
                </Badge>
            </IconButton>
            <Popover
                anchorEl={notificationsAnchorEl}
                open={Boolean(notificationsAnchorEl) && !isBelowMd}
                onClose={() => setNotificationsAnchorEl(null)}
                className="shadow-none translate-y-[6px]"
                elevation={0}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                classes={{
                    paper: 'rounded-lg border',
                }}
                keepMounted
                onTransitionEnd={() => {
                    /**
                     * Due to the indicator width being calculated whilst the popover animation is still running, the indicator width is calculated incorrectly.
                     * This forces the indicator to recalculate its width after the popover animation has finished.
                     * It's ok when we're closing the popover since the indicator is hidden, but when opening the popover, the indicator is visible and needs to be calculated correctly.
                     */
                    tabsActionRef?.current?.updateIndicator?.();
                }}
            >
                <NotificationsBox />
            </Popover>
        </>
    );
};
